import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { Device } from './../../../common/interfaces/item.interface';
import { CommonProgrammingContext } from './../../../common/services/shared-programming.service';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';
import { SensorsService } from '../sensors.service';
import { scheduleQuickstartReducer } from '../../quickstart-schedule/services/schedule.service';

@Component({
  selector: 'prg-select-sensor',
  templateUrl: './select-sensor.component.html',
  styleUrls: ['./select-sensor.component.less']
})
export class SelectSensorComponent implements OnInit {

  devices: Observable<Array<Device>>;
  title: string;

  constructor(
    private store: Store<{ sharedProgramming: CommonProgrammingContext }>,
    private route: ActivatedRoute,
    private router: Router,
    private shared: SharedProgrammingService,
    private utils: Utils,
    private sensors: SensorsService
  ) {
    this.devices = this.store.select(s => s.sharedProgramming.trigger.devices);
  }

  ngOnInit() {
    this.route.data.take(1).subscribe((data: any) => {
      if (data) {
        console.log('route data for select-sensor: ', data);
        if (data.query) {
          this.shared.getTriggerDevices(data.query);
        }

        this.title = 'Select a ' + data.label + ' Sensor';

        if (data.label) {
          // this.shared.addBreadcrumb({ label: data.label, route: Utils.getPathFromRoot(this.route) });
        }
      }
    });
  }

  sensorSelected(sensor: Device) {
    this.shared.setTriggerDevice(sensor);
    this.router.navigate(['../event'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-sensors/select-sensor/select-sensor.component.ts